import React, { useState, useEffect, FC, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Content from "../../layout/content/Content";
import {
  Card,
  Badge,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  Spinner,
  Alert,
} from "reactstrap";
import Head from "../../layout/head/Head";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import { FormProvider, useForm } from "react-hook-form";
import {
  PaperClipOutlined,
  DownloadOutlined,
  UploadOutlined,
  EditOutlined,
  SettingOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Form,
  Input,
  InputNumber,
  Table,
  Collapse as AntCollapse,
  Button as AntButton,
  Descriptions,
  Modal as AntModal,
  Spin,
  Flex,
  Drawer,
  Select,
  Popover,
  DatePicker,
  Empty,
  Popconfirm,
  Radio,
  TimePicker,
  Tooltip,
  Modal as AntdModal,
  message,
  Space
} from "antd";
import FormSelect from "../form-components/SelectComponent";
import FormInput from "../form-components/InputComponent";
import FormDatePicker from "../form-components/DatePicker";
import FormTimePicker from "../form-components/FormTimePicker";
import purchaseOrderApis from "../../api/purchase-orders/pruchaseOrderCreation";
import dayjs from "dayjs";
import axios from "axios";
import statusMapper from "../purchase-orders/StatusMapper";
import { nanoid } from "nanoid";
import Misc from "../masters/Misc";
import invoiceApis from "../../api/Invoice/invoice";
import sequenceApis from "../../api/master/sequence";
import Swal from "sweetalert2";
import CropperComponent from "../components/CropperComponent";
import SignatureModal from "../purchase-orders/SignatureModal";
import Dragger from "antd/es/upload/Dragger";
import { useDispatch } from "react-redux";
import { fetchSequenceAccess } from "../../store/slices/misc/sequenceAccess";
import { formatCurrency } from "../../utils/Utils";
import ExportToXlsx from "../../utils/exportToXlsx";
import BulkMaterialUpload from "../purchase-requests/NewIndent/BulkMaterialUpload";
import GRNApprovalDrawer from "../dispatch/GRNApprovalDrawer";
const { Panel } = AntCollapse;

const { FormatCurrency, beforeUpload } = Misc;
type Cess = {
  cessName: string;
  cessType?: string;
  cessPercentage?: string;
  cessAmount?: string;
};
interface TaxConfiguration {
  taxType: string;
  gstType?: string; //IGST or CGST+SGST
  cess?: Cess[];
}

interface CurrencyData {
  description: string;
  currency_code: string;
  currency_symbol: string;
  currency_format: string;
  example: string;
}

const columns = [
  // {
  //   ...Table.EXPAND_COLUMN,
  //   fixed: "left",
  // },
  // {
  //   title: "#",
  //   key: "#",
  //   width: 50,
  //   // fixed: "left",
  //   render: (text: any, record: any, index: number) => index + 1,
  // },
  {
    title: "Material Name",
    dataIndex: "materialName",
    key: "materialName",
    width: 200,
    fixed: "left",
  },
  {
    title: "Ordered Qty",
    dataIndex: "quantity",
    key: "quantity",
    width: 150,
    render: (text: any, record: any) =>
      `${Number(text)?.toFixed(2)} ${record?.uom}`,
  },
  {
    title: "Available Qty to Invoice",
    dataIndex: "availableQuantity",
    width: 200,
    render: (text: any, record: any) => (
      <div>
        {Number(
          Number(record?.quantity) - Number(record?.quantityInvoiced)
        )?.toFixed(2) +
          " " +
          record?.uom}
      </div>
    ),
  },
  {
    title: "HSN Code",
    dataIndex: "hsnCode",
    key: "hsnCode",
    width: 150,
    editable: true,
  },
  {
    title: "Invoice Qty",
    dataIndex: `invoiceQuantity`,
    key: "invoiceQuantity",
    width: 120,
    editable: true,
    render: (text: any, record: any) => <div></div>,
  },
  {
    title: "Unit Price",
    dataIndex: "unitPrice",
    key: "unitPrice",
    width: 150,
    // editable: true,
  },
  {
    title: "Basic Amount",
    dataIndex: "basicAmount",
    key: "basicAmount",
    width: 200,
  },
  {
    title: "Need By Date",
    dataIndex: "needByDate",
    key: "needByDate",
    width: 150,
    render: (text: any) => dayjs(text).format("DD-MMM-YYYY"),
  },
  {
    title: "SGST",
    dataIndex: "sgst",
    key: "sgst",
    width: 200,
    render: (text: any, record: any) => (
      <div style={{ textAlign: "right" }}>
        <span>
          {Number(record?.sgst) && Number(record?.cgst)
            ? formatCurrency(text, "INR")
            : "N/A"}
        </span>
      </div>
    ),
  },
  {
    title: "CGST",
    dataIndex: "cgst",
    key: "cgst",
    width: 200,
    render: (text: any, record: any) => (
      <div style={{ textAlign: "right" }}>
        <span>
          {Number(record?.sgst) && Number(record?.cgst)
            ? formatCurrency(text, "INR")
            : "N/A"}
        </span>
      </div>
    ),
  },
  {
    title: "IGST",
    dataIndex: "igst",
    key: "igst",
    width: 200,
    render: (text: any, record: any) => (
      <div style={{ textAlign: "right" }}>
        <span>
          {!Number(record?.sgst) && !Number(record?.cgst)
            ? formatCurrency(text, "INR")
            : "N/A"}
        </span>
      </div>
    ),
  },
  {
    title: "Line Total",
    dataIndex: "grossTotal",
    key: "grossTotal",
    width: 250,
  },
  {
    title: "Invoices",
    dataIndex: "operation",
    width: 100,
    fixed: "right",
  },
];

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}: any) => {
  const rules: any = [
    {
      required: true,
      message: `${title} is required`,
    },
  ];
  let pattern: any = undefined;
  if (dataIndex != "hsnCode") {
    rules.push({
      type: "number",
      min: 0.01,
      message: `${title} must > 0`,
    });
  }
  // Add validation for Invoice Qty to not exceed Available Qty to Invoice
  if (dataIndex === "invoiceQuantity") {
    const availableQuantity =
      Number(record?.quantity) - Number(record?.quantityInvoiced || 0);
    rules.push({
      type: "number",
      max: availableQuantity,
      message: `Invoice Qty cannot exceed Available Qty to Invoice (${availableQuantity.toFixed(
        2
      )} ${record?.uom || ""})`,
    });
  }
  if (dataIndex === "hsnCode") {
    rules.push({
      validator: (_: any, value: any) => {
        if (value === undefined || value === null || value === "") {
          return Promise.resolve();
        }
        const str = String(value);
        if (/^[0-9]{4,8}$/.test(str)) {
          return Promise.resolve();
        }
        return Promise.reject(new Error("HSN Code must be 4-8 digits"));
      },
    });
  }
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex + `_${record.lineNo}`}
          style={{ margin: 0 }}
          rules={rules}
          initialValue={Number(record[dataIndex])}
        >
          <InputNumber
            // defaultValue={Number(record[dataIndex])}
            className="w-100"
            pattern={pattern}
            formatter={(value) =>
              dataIndex != "hsnCode"
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : `${value}`
            }
            parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
            onKeyPress={(event) => {
              const regex =
                dataIndex === "hsnCode" ? /^[0-9\b]+$/ : /^[0-9\b\.]+$/;
              if (!regex.test(event.key)) {
                event.preventDefault();
              }
            }}
            onPaste={(event) => {
              if (dataIndex === "hsnCode") {
                const pasted = event.clipboardData.getData("text");
                if (!/^[0-9]*$/.test(pasted)) {
                  event.preventDefault();
                }
              }
            }}
            maxLength={dataIndex === "hsnCode" ? 8 : undefined}
            step={dataIndex != "hsnCode" ? 0.01 : 1}
          />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const PoInvoiceDetails: FC<any> = () => {
  const [disableSubmit, setDisableSubmit] = useState(false);
  const { orderNumber }: any = useParams();
  const dispatch: any = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { Option } = Select;
  const [OriginalData, setOriginalData] = useState<any>({});
  const [invoiceableLines, setInvoiceableLines] = useState<any>([]);
  const [sm, setSm] = useState(false);
  const [tab, setTab] = useState("1");
  const [poStatus, setPoStatus] = useState<any>("");
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [taxConfiguration, setTaxConfiguration] = useState<TaxConfiguration>();
  const [instructionsVisible, setInstructionsVisible] = useState(false);
  const [termsVisible, setTermsVisible] = useState(false);
  const [materialData, setMaterialData] = useState<any>({});
  const [attachments, setAttachments] = useState<any>([]);
  const [invoiceAttachments, setInvoiceAttachments] = useState<any>([]);
  const [signature, setSignature] = useState<any>([]);
  const [invoiceSignature, setInvoiceSignature] = useState<any>({});
  const [invoiceDate, setInvoiceDate] = useState<any>();
  const [grnRequired, setGrnRequired] = useState(null);

  const [currency, setCurrency] = useState<CurrencyData>({
    description: "",
    currency_code: "",
    currency_symbol: "",
    currency_format: "",
    example: "",
  });
  const [generalInformationEdit, setGeneralInformationEdit] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState<any>("");
  const [instructions, setInstructions] = useState("");

  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [editingKeys, setEditingKeys] = useState<string[]>([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [deliveryAddressList, setDeliveryAddressList] = useState<any>([]);
  const [selectedDeliveryAddress, setSelectedDeliveryAddress] =
    useState<any>(null);
  const [selectedNeedByDate, setSelectedNeedByDate] = useState<any>(null);
  const [needByDateList, setNeedByDateList] = useState<any>([]);
  const isEditing = (record: any) => editingKeys.includes(record.lineNo);
  const [showCropModel, setShowCropModel] = useState<boolean>(false);
  const [showSignatureModel, setShowSignatureModel] = useState<boolean>(false);
  const [uploadedDataErrors, setUploadedDataErrors] = useState<any>([]);
  const [uploadedDataErrorModal, setUploadedDataErrorModal] = useState(false);
  const bulkUploadErrorsRef = useRef<HTMLDivElement>(null);
  const [showMoreTransportFields, setShowMoreTransportFields] = useState(false);
  const [gateEntriesOptions, setGateEntriesOptions] = useState<any[]>([]);
  const [selectedGateEntry, setSelectedGateEntry] = useState<any>(null);
  const [isLoadingGateEntries, setIsLoadingGateEntries] = useState(false);
  const [grnSequenceAccess, setGrnSequenceAccess] = useState<{
    level: string;
    siteIds: string[];
  }>({ level: "", siteIds: [] });

  const [activeSequences, setActiveSequences] = useState<any[]>([]);
  const [numberingMode, setNumberingMode] = useState<'auto' | 'manual'>('auto');
  const [showNumberingModal, setShowNumberingModal] = useState(false);
  const [tempNumberingMode, setTempNumberingMode] = useState<'auto' | 'manual'>('auto');

  useEffect(() => {
    dispatch(fetchSequenceAccess());
    fetchGrnSequenceStatus();
  }, [dispatch]);

  const handleGrnRequiredChange = (value: any) => {
    setGrnRequired(value);
  };

  const fetchGateEntries = async (siteId: number) => {
    if (!siteId) return;
    try {
      setIsLoadingGateEntries(true);
      const response = await invoiceApis.fetchGateEntriesDropDownBySiteId(
        siteId
      );
      // Handle different response structures
      const data = response?.data || response?.response?.data || response;
      if (Array.isArray(data) && data.length > 0) {
        const options = data.map((item: any) => ({
          label: item.gateEntryNumber || item.gateEntrySequenceId,
          value: item.gateEntryId,
          gateEntryId: item.gateEntryId,
          gateEntryNumber: item.gateEntryNumber,
        }));
        setGateEntriesOptions(options);
      } else {
        setGateEntriesOptions([]);
      }
    } catch (error) {
      console.log("Error fetching gate entries:", error);
      setGateEntriesOptions([]);
    } finally {
      setIsLoadingGateEntries(false);
    }
  };

  const fetchGrnSequenceStatus = async () => {
    try {
      const response = await sequenceApis.fetchSequenceByModuleId(8);
      const { data } = response;
      const today = new Date();
      // Check if sequence exists with:
      // 1. moduleId === 8 (GRN)
      // 2. status === "Active" (if "Active", hide GRN ID field)
      // 3. endDate is in the future
      const _sequenceAccess = data?.filter(
        (item: any) =>
          item.moduleId === 8 &&
          item.status === "Active" &&
          new Date(item.endDate) > today
      );
      if (_sequenceAccess?.length > 0) {
        setGrnSequenceAccess({
          level: _sequenceAccess[0].level || "",
          siteIds: _sequenceAccess
            ?.map((item: any) => item?.siteId?.toString())
            .filter(Boolean),
        });
      } else {
        setGrnSequenceAccess({ level: "", siteIds: [] });
      }
    } catch (error: any) {
      console.log(error.response?.data?.message || "An error occurred");
      setGrnSequenceAccess({ level: "", siteIds: [] });
    }
  };

  const mergedColumns = columns.map((col: any) => {
    if (col.dataIndex == "operation") {
      return {
        title: "Invoices",
        dataIndex: "operation",
        width: 100,
        fixed: "right",
        render: (text: any, record: any) => {
          return ["PartiallyInvoiced", "FullyInvoiced"].includes(
            record?.invoiceStatus
          ) ? (
            <Button
              size="sm"
              color=""
              onClick={() => {
                navigate(
                  `/view-material-invoices/${orderNumber}/${record.lineNo}`
                );
              }}
            >
              <Icon name="focus" />
            </Button>
          ) : (
            <></>
          );
        },
      };
    } else if (
      [
        "basicAmount",
        // "sgst", "cgst", "igst",
        "grossTotal",
      ].includes(col.dataIndex)
    ) {
      return {
        ...col,
        render: (text: any, record: any) => (
          <div style={{ textAlign: "right" }}>
            <span>{FormatCurrency(text, currency?.currency_code)}</span>
          </div>
        ),
      };
    } else if (col.dataIndex == "unitPrice") {
      col = {
        ...col,
        render: (text: any, record: any) => (
          <div style={{ textAlign: "right" }}>
            <span>{FormatCurrency(text, currency?.currency_code)}</span>
          </div>
        ),
      };
    } else if (col.dataIndex == "needByDate") {
      if (OriginalData?.needByDateType == "Order Level") {
        return {
          ...col,
          hidden: true,
        };
      } else {
        return col;
      }
    }
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: any) => ({
        record,
        inputType: col.dataIndex === "quantity" ? "number" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (!newSelectedRowKeys) {
      editingKeys.forEach((key) => {
        const row = data.find((item: any) => item.lineNo == key);
        form.setFieldsValue({ [`invoiceQuantity_${row.lineNo}`]: 0 });
        // form.setFieldsValue({ [`invoiceQuantity_${row.lineNo}`]: null });
        form.setFieldsValue({
          [`unitPrice_${row.lineNo}`]: Number(row.unitPrice),
        });
        form.setFieldsValue({ [`hsnCode_${row.lineNo}`]: Number(row.hsnCode) });
      });
      setEditingKeys(() => []);
      form.resetFields();
    }
    const unSelectedRowKeys = selectedRowKeys.filter(
      (key) => !newSelectedRowKeys.includes(key)
    );
    unSelectedRowKeys?.forEach((key) => {
      const row = data.find((item: any) => item.lineNo == key);
      form.setFieldsValue({ [`invoiceQuantity_${row.lineNo}`]: 0 });
      // form.setFieldsValue({ [`invoiceQuantity_${row.lineNo}`]: null });
      form.setFieldsValue({
        [`unitPrice_${row.lineNo}`]: Number(row.unitPrice),
      });
      form.setFieldsValue({ [`hsnCode_${row.lineNo}`]: Number(row.hsnCode) });
    });
    const editableRowKeys: any = [];
    newSelectedRowKeys?.forEach((key) => {
      const row = data.find((item: any) => item.lineNo == key);
      if (row) {
        form.setFieldsValue({ ...row });
        editableRowKeys.push(row.lineNo);
      }
    });
    setEditingKeys(editableRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const showDrawer = async () => {
    try {
      const rows = await form.validateFields();
      const invoiceLines: any = [];
      data.forEach((item: any) => {
        if (
          editingKeys.includes(item.lineNo) &&
          Number(rows[`invoiceQuantity_` + item.lineNo]) > 0
        ) {
          const quantity = rows[`invoiceQuantity_` + item.lineNo];
          const unitPrice =
            rows[`unitPrice_` + item.lineNo] || Number(item.unitPrice);
          const hsnCode =
            rows[`hsnCode_` + item.lineNo] || Number(item.hsnCode);
          const basicAmount = quantity * unitPrice;
          const sgst = (basicAmount * Number(item.sgstPercentage)) / 100;
          const igst = (basicAmount * Number(item.igstPercentage)) / 100;
          const cgst = (basicAmount * Number(item.cgstPercentage)) / 100;
          invoiceLines.push({
            ...item,
            quantity,
            unitPrice,
            basicAmount,
            hsnCode,
            sgst,
            igst,
            cgst,
            grossTotal: basicAmount + sgst + igst + cgst,
          });
        }
      });
      setInvoiceableLines(invoiceLines);
      // Set default values for the drawer form before opening
      const defaultDueDate = dayjs().add(
        Number(materialData?.creditDays) || 0,
        "day"
      );
      reset2({
        dueDate: defaultDueDate,
      });
      setDrawerVisible(true);
    } catch (error) {
      console.log(error);
    }
  };

  const closeDrawer = () => {
    reset2();
    setDrawerVisible(false);
    setShowMoreTransportFields(false);
    setSelectedGateEntry(null);
  };

  const [approvals, setApprovals] = useState({
    open: false,
    data: [],
  });
  const [isStrictApproval, setIsStrictApproval] = useState<boolean>(false);

  const methods = useForm({
    mode: "onChange",
  });

  const methods2 = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = methods;

  const siteIdWatch = watch("siteId");

  const {
    handleSubmit: handleSubmit2,
    reset: reset2,
    watch: watch2,
    setValue: setValue2,
    getValues: getValue2,
    formState: { errors: errors2 },
  } = methods2;

  const [data, setData] = useState<any>([]);
  const [filterData, setFilterData] = useState<any>([]);

  const fetchOrderDetails = async () => {
    try {
      const res = await purchaseOrderApis.fetchOrder(orderNumber);
      const { data, status, message } = res;
      if (status) {
        const {
          currencyCode,
          currencySymbol,
          currencyFormat,
          dms,
          signatureLabel,
          igst,
        } = data;
        setOriginalData(data);
        setPoStatus(data?.orderStatus);
        if (Number(igst) == 0) {
          setTaxConfiguration({
            taxType: "GST",
            gstType: "CGST+SGST",
            cess: [],
          });
        }
        setCurrency({
          description: currencyCode,
          currency_code: currencyCode,
          currency_symbol: currencySymbol,
          currency_format: currencyFormat,
          example: currencyCode,
        });
        if (dms?.length > 0) {
          const _signature = dms?.find(
            (item: any) => item.moduleFileType == "signature"
          );
          if (_signature) {
            setSignature({
              docId: _signature?.docId,
              fileName: _signature?.fileName,
              image: _signature?.filePath,
              moduleFileType: _signature?.moduleFileType,
              module: _signature?.module,
              label: signatureLabel,
              isActive: true,
            });
          }
          const _attachments = dms?.filter(
            (item: any) => item.moduleFileType == "attachments"
          );
          if (_attachments) {
            setAttachments(
              _attachments.map((attachment: any) => ({
                docId: attachment?.docId,
                name: attachment?.fileName,
                link: attachment?.filePath,
                moduleFileType: attachment?.moduleFileType,
                module: attachment?.module,
                label: "attachments",
                isActive: true,
              }))
            );
          }
        }
        const _termsAndConditions = dms?.find(
          (item: any) => item.moduleFileType == "termsAndConditions"
        );
        if (_termsAndConditions) {
          const data: any = await fetchHtmlContentFromUrl(
            _termsAndConditions?.filePath
          );
          setTermsAndConditions(data);
        }
        const _instructions = dms?.find(
          (item: any) => item.moduleFileType == "instructions"
        );
        if (_instructions) {
          const data: any = await fetchHtmlContentFromUrl(
            _instructions?.filePath
          );
          setInstructions(data);
        }
        setMaterialData(data);
        // Fetch gate entries when siteId is available
        if (data?.siteId) {
          fetchGateEntries(Number(data.siteId));
        }
        const _DeliveryAddressList: any = [];
        const _needByDateList: any = [];
        const LineItems = data?.lineItems?.map((item: any) => {
          if (data?.deliveryAddressType == "Line Level") {
            if (
              !_DeliveryAddressList?.find(
                (address: any) => address?.id == item?.deliveryAddress?.id
              )
            ) {
              _DeliveryAddressList.push({ ...item?.deliveryAddress });
            }
          }
          if (data?.needByDateType == "Line Level") {
            if (
              !_needByDateList?.find((date: any) => date == item?.needByDate)
            ) {
              _needByDateList.push(item?.needByDate);
            }
          }
          const file = dms?.find((doc: any) => doc.lineNo == item.lineNo);
          if (file) {
            item.file = file;
          }
          return item;
        });
        setNeedByDateList(_needByDateList);
        if (_needByDateList?.length == 1) {
          setSelectedNeedByDate(_needByDateList[0]);
        }
        setDeliveryAddressList(_DeliveryAddressList);
        if (_DeliveryAddressList?.length == 1) {
          setSelectedDeliveryAddress(_DeliveryAddressList[0]?.id);
        }
        setData(LineItems);
        setFilterData(LineItems);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const ViewTableTotals = ({ data, additionalCharges, invoice }: any) => {
    let totalNetAmmount = 0,
      cgst = 0,
      sgst = 0,
      igst = 0,
      TotalAmount = 0;
    data?.forEach((item: any) => {
      const totalAmmount = Number(item.unitPrice) * Number(item.quantity);
      cgst = cgst + (totalAmmount * Number(item.cgstPercentage)) / 100;
      sgst = sgst + (totalAmmount * Number(item.sgstPercentage)) / 100;
      igst = igst + (totalAmmount * Number(item.igstPercentage)) / 100;
      totalNetAmmount = totalNetAmmount + totalAmmount;
    });
    TotalAmount = totalNetAmmount + cgst + sgst + igst;
    additionalCharges?.forEach((item: any) => {
      TotalAmount = TotalAmount + Number(item.price);
    });
    return (
      <Row
        className={`${invoice && "w-50 mt-2"}`}
        style={{
          margin: "20px",
        }}
      >
        <Col className={`justify-end`}>
          <div className={`${invoice ? "w-100" : "w-40"}`}>
            <div className="d-flex justify-content-between">
              <div className="w-50 justify-end">
                <strong>Taxable Amount</strong>
              </div>
              <span className="r_align">
                {FormatCurrency(totalNetAmmount, currency?.currency_code)}
              </span>
            </div>
            {cgst && sgst ? (
              <>
                <div className="d-flex justify-content-between">
                  <div className="w-50 justify-end">
                    <strong>CGST</strong>
                  </div>
                  <span className="r_align">
                    {FormatCurrency(cgst, currency?.currency_code)}
                  </span>
                </div>
                <div className="d-flex justify-content-between">
                  <div className="w-50 justify-end">
                    <strong>SGST</strong>
                  </div>
                  <span className="r_align">
                    {FormatCurrency(sgst, currency?.currency_code)}
                  </span>
                </div>
              </>
            ) : (
              <div className="d-flex justify-content-between">
                <div className="w-50 justify-end">
                  <strong>IGST</strong>
                </div>
                <span className="r_align">
                  {FormatCurrency(igst, currency?.currency_code)}
                </span>
              </div>
            )}

            <div
              className="d-flex justify-content-between"
              style={{ fontSize: "18px", marginTop: "10px" }}
            >
              <div className="w-50 justify-end">
                <strong>Total</strong>
              </div>
              <strong className="r_align">
                {FormatCurrency(TotalAmount, currency?.currency_code)}
              </strong>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  useEffect(() => {
    fetchOrderDetails();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);
  const ShowBillingAddress = ({ address }: any) => {
    if (!address) return <></>;
    const {
      deliveryLocationName,
      addressLine1,
      addressLine2,
      city,
      pincode,
      state,
      district,
      countryInfo,
    } = address;
    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>{deliveryLocationName}</strong>
        </li>
        <li>
          {[
            // deliveryLocationName,
            addressLine1,
            addressLine2,
            city,
            district?.districtName,
          ]
            .filter(Boolean)
            .join(", ")}
        </li>
        <li>
          {[state?.stateName, countryInfo?.countryName, pincode]
            .filter(Boolean)
            .join(", ")}
        </li>
      </ul>
    );
  };
  const ShowDeliveryAddress = ({ address }: any) => {
    if (!address) return <></>;
    const {
      deliveryLocationName,
      addressLine1,
      addressLine2,
      city,
      pincode,
      state,
      district,
      countryInfo,
    } = address;
    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>{deliveryLocationName}</strong>
        </li>
        <li>
          {[
            // deliveryLocationName,
            addressLine1,
            addressLine2,
            city,
            district?.districtName,
          ]
            .filter(Boolean)
            .join(", ")}
        </li>
        <li>
          {[state?.stateName, countryInfo?.countryName, pincode]
            .filter(Boolean)
            .join(", ")}
        </li>
      </ul>
    );
  };

  const handleChange = (info: any) => {
    let files = info.fileList.slice(-3); // Limit to 3 files
    setInvoiceAttachments(files);
  };

  useEffect(() => {
    let _filterData = data;
    if (selectedNeedByDate) {
      _filterData = _filterData.filter(
        (item: any) => item.needByDate == selectedNeedByDate
      );
    }
    if (selectedDeliveryAddress) {
      _filterData = _filterData.filter(
        (item: any) => item.deliveryAddressId == selectedDeliveryAddress
      );
    }
    setFilterData(_filterData);
  }, [selectedDeliveryAddress, selectedNeedByDate, data]);

  useEffect(() => {
    if (grnRequired !== "false") {
      setShowMoreTransportFields(false);
    }
  }, [grnRequired]);

  const createInvoice = async (Data: any) => {
    setValue("numberingMode", numberingMode);
    try {
      const _formData = new FormData();
      const filesData = [];
      if (invoiceAttachments?.length > 0) {
        invoiceAttachments?.forEach((item: any) => {
          _formData.append("files", item?.originFileObj);
          filesData.push({
            indexOfFileLocated: filesData.length,
            purpose: "attachment",
            module: "invoice",
            level: "Header Level",
            uniqueId: nanoid(4),
            action: "Create",
          });
        });
      }
      const invoiceData: any = {
        selfInvoice: true,
        referenceId: nanoid(4),
        orderNumber: Number(orderNumber),
        eWayBillNumber: Data?.ewayBill,
        invoiceId: Data?.invoiceId,
        irn: Data?.referenceId,
        mode: "F",
        invoiceType: "commercial",
        invoiceDate: Data?.invoiceDate?.format("YYYY-MM-DD"),
        dueDate: Data?.dueDate?.format("YYYY-MM-DD"),
        deliveryAddressId:
          selectedDeliveryAddress || materialData?.deliveryAddressId,
        autoRelease: true,
        additionalChargesArray: [],
        lineItems: invoiceableLines?.map((line: any) => {
          return {
            uuid: line?.uuid,
            orderLineNo: line?.lineNo,
            materialId: line?.materialId,
            hsnCode: line?.hsnCode,
            categoryId: line?.categoryId,
            description: line?.description,
            quantityInvoiced: line?.quantity,
            uomId: line?.uomId,
            unitPrice: line?.unitPrice,
            discountPercentage: Number(line?.discountPercentage),
            sgstPercentage: Number(line?.sgstPercentage),
            cgstPercentage: Number(line?.cgstPercentage),
            igstPercentage: Number(line?.igstPercentage),
            additionalCharges: 0,
          };
        }),
      };

      const grnRequired = JSON.parse(Data?.GrnRequired);
      const driverInfo: any = {};

      // Only include fields that have values (check for undefined and null, not falsy values)
      if (
        Data?.driverName !== undefined &&
        Data?.driverName !== null &&
        Data?.driverName !== ""
      )
        driverInfo.name = Data.driverName;
      if (
        Data?.driverContact !== undefined &&
        Data?.driverContact !== null &&
        Data?.driverContact !== ""
      )
        driverInfo.mobile = Data.driverContact;
      if (
        Data?.driverEmail !== undefined &&
        Data?.driverEmail !== null &&
        Data?.driverEmail !== ""
      )
        driverInfo.email = Data.driverEmail;
      if (
        Data?.vehicleNumber !== undefined &&
        Data?.vehicleNumber !== null &&
        Data?.vehicleNumber !== ""
      )
        driverInfo.vehicleNumber = Data.vehicleNumber;
      if (
        Data?.vehicleType !== undefined &&
        Data?.vehicleType !== null &&
        Data?.vehicleType !== ""
      )
        driverInfo.vehicleType = Data.vehicleType;
      if (
        selectedGateEntry?.gateEntryId !== undefined &&
        selectedGateEntry?.gateEntryId !== null
      ) {
        driverInfo.gateEntryId = selectedGateEntry.gateEntryId;
      }
      if (
        selectedGateEntry?.gateEntryNumber !== undefined &&
        selectedGateEntry?.gateEntryNumber !== null
      ) {
        driverInfo.gateEntryNumber = selectedGateEntry.gateEntryNumber;
      }
      if (
        Data?.dharamkantaReceiptNo !== undefined &&
        Data?.dharamkantaReceiptNo !== null &&
        Data?.dharamkantaReceiptNo !== ""
      )
        driverInfo.dharamKantaRecieptNo = Data.dharamkantaReceiptNo;
      if (
        Data?.dmrNo !== undefined &&
        Data?.dmrNo !== null &&
        Data?.dmrNo !== ""
      )
        driverInfo.dmrNo = Data.dmrNo;
      if (
        Data?.weighbridgeSlipNo !== undefined &&
        Data?.weighbridgeSlipNo !== null &&
        Data?.weighbridgeSlipNo !== ""
      )
        driverInfo.weighbridgeSlipNo = Data.weighbridgeSlipNo;
      if (
        Data?.ticketNo !== undefined &&
        Data?.ticketNo !== null &&
        Data?.ticketNo !== ""
      )
        driverInfo.ticketNo = Data.ticketNo;
      if (
        Data?.youtubeLink !== undefined &&
        Data?.youtubeLink !== null &&
        Data?.youtubeLink !== ""
      )
        driverInfo.youTubeLink = Data.youtubeLink;
      if (
        Data?.loadTruckWeight !== undefined &&
        Data?.loadTruckWeight !== null &&
        Data?.loadTruckWeight !== ""
      )
        driverInfo.loadTruckWeight = Data.loadTruckWeight;
      if (
        Data?.emptyTruckWeight !== undefined &&
        Data?.emptyTruckWeight !== null &&
        Data?.emptyTruckWeight !== ""
      )
        driverInfo.emptyTruckWeight = Data.emptyTruckWeight;
      if (
        Data?.netWeight !== undefined &&
        Data?.netWeight !== null &&
        Data?.netWeight !== ""
      )
        driverInfo.netWeight = Data.netWeight;
      if (
        Data?.vehicleInTime !== undefined &&
        Data?.vehicleInTime !== null &&
        Data?.vehicleInTime !== ""
      ) {
        try {
          driverInfo.vehicleInTime = dayjs(Data.vehicleInTime).format(
            "hh:mm A"
          );
        } catch {
          driverInfo.vehicleInTime = Data.vehicleInTime;
        }
      }
      if (
        Data?.vehicleOutTime !== undefined &&
        Data?.vehicleOutTime !== null &&
        Data?.vehicleOutTime !== ""
      ) {
        try {
          driverInfo.vehicleOutTime = dayjs(Data.vehicleOutTime).format(
            "hh:mm A"
          );
        } catch {
          driverInfo.vehicleOutTime = Data.vehicleOutTime;
        }
      }
      if (
        Data?.loadTruckWeightInHouse !== undefined &&
        Data?.loadTruckWeightInHouse !== null &&
        Data?.loadTruckWeightInHouse !== ""
      )
        driverInfo.loadTruckWeightInHouse = Data.loadTruckWeightInHouse;
      if (
        Data?.emptyTruckWeightInHouse !== undefined &&
        Data?.emptyTruckWeightInHouse !== null &&
        Data?.emptyTruckWeightInHouse !== ""
      )
        driverInfo.emptyTruckWeightInHouse = Data.emptyTruckWeightInHouse;
      if (
        Data?.netWeightInHouse !== undefined &&
        Data?.netWeightInHouse !== null &&
        Data?.netWeightInHouse !== ""
      )
        driverInfo.netWeightInHouse = Data.netWeightInHouse;

      const autoReleaseValue = Data?.autoRelease === "true";
      const grnApprovalHierarchy = approvals?.data || [];

      // Validation: If Approval Required is Yes, check if approvals are set
      if (autoReleaseValue && (!grnApprovalHierarchy || grnApprovalHierarchy.length === 0)) {
        Swal.fire({
          icon: "warning",
          title: "Approvals Required",
          text: "Please set approvals before creating invoice.",
          confirmButtonText: "OK",
        });
        setDisableSubmit(false);
        return;
      }

      const selfDispatchData: any = {
        grnRequired,
        // ...(!grnRequired && { grnId: Data?.grnId }),
        ...(Data?.grnCreatedDate && {
          grnCreatedDate: Data?.grnCreatedDate?.format("YYYY-MM-DD"),
        }),
        driverInfo,
      };

      if(grnRequired){
        selfDispatchData.autoRelease = false
      }
      
      // Add grnId only in manual mode
      if (!grnRequired && numberingMode === 'manual') {
        selfDispatchData.grnId = Data?.grnId;
      }

      if (!grnRequired) {
        // Approval Required = YES (autoReleaseValue is true)
        if (autoReleaseValue) {
          selfDispatchData.autoRelease = false;
          selfDispatchData.grnApprovalHierarchy = grnApprovalHierarchy;
          selfDispatchData.isStrictApproval = Boolean(isStrictApproval);
        }
        // Approval Required = NO (autoReleaseValue is false)
        else {
          selfDispatchData.autoRelease = true;
        }
      } else {
        console.log("Case 3: GRN Required = true", {
          grnRequired,
          selfDispatchData
        });
      }

      if (invoiceSignature?.image) {
        const image = base64ToFile(invoiceSignature?.image, "signature.png");
        invoiceData.signatureLabel = invoiceSignature?.label;
        _formData.append("files", image);
        filesData.push({
          indexOfFileLocated: filesData.length,
          module: "invoice",
          purpose: "signature",
          level: "Header Level",
          uniqueId: nanoid(4),
          action: "Create",
        });
      }
      _formData.append("selfDispatchData", JSON.stringify(selfDispatchData));
      _formData.append("invoiceData", JSON.stringify(invoiceData));
      _formData.append("filesData", JSON.stringify(filesData));
      _formData.append("invoiceApprovalHierarchy", JSON.stringify([]));
      _formData.append("files", JSON.stringify([]));

      const response = await invoiceApis.submitInvoice(_formData);
      const { status, message, data: _data } = response;
      if (status) {
        Swal.fire({
          icon: "success",
          title: "Invoice Generated",
          text: _data,
        });
        closeDrawer();
        setIsLoading(true);
        navigate("/view-invoice-list");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: message,
          confirmButtonText: "OK",
        });
      }
      setDisableSubmit(false);
    } catch (error) {
      console.log(error);
      setDisableSubmit(false);
    }
  };

  function base64ToFile(base64String: string, fileName: string) {
    const byteString = atob(base64String.split(",")[1]);
    const mimeString = base64String.split(",")[0].split(":")[1].split(";")[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: mimeString });
    return new File([blob], fileName, { type: mimeString });
  }

  const fetchGRNSequenceAccess = async () => {
    try {
      const response = await sequenceApis.fetchSequence();
      const { data } = response;
      const today = new Date();
      const _sequenceAccess = data?.filter(
        (item: any) =>
          item.moduleName === "GRN" &&
          new Date(item.endDate) > today &&
          item.status === "Active"
      );
      setActiveSequences(_sequenceAccess || []);

      // Set initial numbering mode based on available sequences
      const siteId = materialData?.siteId?.toString();
      if (_sequenceAccess && _sequenceAccess.length > 0 && siteId) {
        // Check if current site has a sequence
        const siteHasSequence = _sequenceAccess.some(
          (seq: any) => seq.siteId?.toString() === siteId
        );
        setNumberingMode(siteHasSequence ? 'auto' : 'manual');
      } else {
        setNumberingMode('manual');
      }
    } catch (error: any) {
      setActiveSequences([]);
      setNumberingMode('manual');
    }
  };

  useEffect(() => {
    if (materialData?.siteId) {
      fetchGRNSequenceAccess();
    } else {
      setActiveSequences([]);
    }
  }, [materialData?.siteId]);

  const getCurrentSiteSequence = () => {
    const siteId = materialData?.siteId?.toString();
    if (!siteId || activeSequences.length === 0) return null;

    const siteSequence = activeSequences.find(
      (seq) =>
        seq.level === "Site" &&
        seq.siteId?.toString() === siteId?.toString()
    );

    if (siteSequence) return siteSequence;

    const orgSequence = activeSequences.find(
      (seq) => seq.level === "Org"
    );

    if (orgSequence) return orgSequence;

    return null;
  };

  const currentSiteSequence = getCurrentSiteSequence();
  const canAuto = !!materialData?.siteId && !!currentSiteSequence;

  // Auto-generate number when in auto mode
  useEffect(() => {
    if (materialData?.siteId && numberingMode === 'auto' && currentSiteSequence) {
      const { prefix } = currentSiteSequence;
      const grnNumber = `${prefix}`;
      setTimeout(() => {
        setValue2("grnId", grnNumber);
        const inputElement = document.querySelector('input[name="grnId"]') as HTMLInputElement;
        if (inputElement) {
          inputElement.value = grnNumber;
          const event = new Event('input', { bubbles: true });
          inputElement.dispatchEvent(event);
        }
      }, 100);
    }
  }, [materialData?.siteId, numberingMode, currentSiteSequence]);

  useEffect(() => {
    if (drawerVisible && materialData?.siteId && numberingMode === 'auto' && currentSiteSequence) {
      const { prefix } = currentSiteSequence;
      const grnNumber = `${prefix}`;
      setValue2("grnId", grnNumber);
    }
  }, [drawerVisible, materialData?.siteId, numberingMode, currentSiteSequence]);
  const prevSiteRef = useRef();

  // Set initial mode based on site selection
  useEffect(() => {
    const currentSiteId = materialData?.siteId;
    const prevSite = prevSiteRef.current;

    // Only run if site actually changed
    if (prevSite && prevSite !== currentSiteId) {
      setValue2("grnId", "");
    }

    if (!currentSiteId) {
      setNumberingMode("manual");
    } else {
      const siteSequence = getCurrentSiteSequence();
      setNumberingMode(siteSequence ? "auto" : "manual");
    }

    prevSiteRef.current = currentSiteId;
  }, [materialData?.siteId]);


  return isLoading == true ? (
    <>
      <Flex align="center" gap="middle" className="pageLoader">
        <Spin size="large" />
      </Flex>
    </>
  ) : (
    <>
      <Head title="Purchase Order - Track" />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {/* <div
              className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
                sm ? "content-active" : ""
              }`}
            >
              <PurchaseOrderAside updateSm={setSm} sm={sm} />
            </div> */}
            <div className="card-inner card-inner-lg">
              {sm && mobileView && (
                <div
                  className="toggle-overlay"
                  onClick={() => setSm(!sm)}
                ></div>
              )}
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent>
                    <BlockTitle tag="h4">
                      <span>
                        {OriginalData.orderId} |{" "}
                        {(statusMapper[poStatus] &&
                          statusMapper[poStatus]?.seller?.title) ||
                          poStatus}{" "}
                      </span>
                    </BlockTitle>
                  </BlockHeadContent>
                  <Button
                    className="toggle"
                    color="primary"
                    onClick={async () => {
                      navigate(
                        `/view-purchase-order/${OriginalData.orderNumber}`
                      );
                    }}
                  >
                    <Icon name="arrow-left" />
                    <span>Back</span>
                  </Button>
                  <BlockHeadContent className="align-self-start d-lg-none">
                    <Button
                      className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""
                        }`}
                      onClick={() => setSm(!sm)}
                    >
                      <Icon name="menu-alt-r" />
                    </Button>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>
              <div className="content clearfix">
                <AntCollapse defaultActiveKey={["1", "2", "3"]}>
                  <Panel header="General Information" key="1">
                    <ul className="nav nav-tabs nav-tabs-card nav-tabs-xs w-100 p-0 m-0 position-relative">
                      <li className="nav-item" onClick={() => setTab("1")}>
                        <a
                          onClick={(ev) => {
                            ev.preventDefault();
                          }}
                          className={`nav-link${tab === "1" ? " active" : ""}`}
                          href="#year"
                        >
                          General Info
                        </a>
                      </li>
                      <li className="nav-item" onClick={() => setTab("2")}>
                        <a
                          href="#overview"
                          onClick={(ev) => {
                            ev.preventDefault();
                          }}
                          className={`nav-link${tab === "2" ? " active" : ""}`}
                        >
                          Delivery Info
                        </a>
                      </li>
                      {tab == "2" &&
                        materialData?.needByDateType == "order Level" && (
                          <span
                            className="cursor-pointer position-absolute"
                            style={{
                              right: 20,
                              top: 10,
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              if (tab === "2") {
                                setValue(
                                  "inwardRequired",
                                  materialData?.inwardRequired
                                );
                                setValue(
                                  "needByDateType",
                                  materialData?.needByDateType
                                );
                                setValue(
                                  "needByDate",
                                  dayjs(materialData?.needByDate)
                                );
                                setValue(
                                  "billingAddress",
                                  materialData?.deliveryAddress
                                    ?.deliveryLocationName
                                );
                                setValue(
                                  "deliveryAddressType",
                                  materialData?.deliveryAddressType
                                );
                                setValue(
                                  "deliveryAddress",
                                  materialData?.deliveryAddress
                                    ?.deliveryLocationName
                                );
                              }
                              setGeneralInformationEdit(true);
                            }}
                          >
                            <Icon name="edit" />
                          </span>
                        )}
                    </ul>

                    <div className="tab-content mt-0">
                      {tab === "1" && (
                        <div className={`tab-pane${tab === "1" && " active"}`}>
                          <Col className="justify-start w-100  flex-wrap mt-3 p-3">
                            <div className="w-30 border-end ">
                              <div className="data-col align-center pt-1 ">
                                <div className="data-label w-30">Site</div>
                                <div className="data-value w-70 ">
                                  {materialData?.siteName}
                                </div>
                              </div>
                              <div className="data-col align-center pt-1 ">
                                <div className="data-label w-30">Supplier</div>
                                <div className="data-value w-70 ">
                                  {materialData?.supplierName}
                                </div>
                              </div>
                              <div className="data-col align-center pt-1">
                                <div className="data-label w-30">
                                  Description
                                </div>
                                <div className="data-value w-70">
                                  {materialData?.description || "--"}
                                </div>
                              </div>
                            </div>
                            <div className="w-30 paddingLeft10 ">
                              <div className="data-col align-center pt-1 ">
                                <div className="data-label w-30">
                                  Payment Terms
                                </div>
                                <div className="data-value w-70 ">
                                  <Badge color="outline-success">
                                    {materialData?.paymentTerms || "--"}
                                  </Badge>
                                </div>
                              </div>
                              {materialData?.paymentTerms == "Advance" && (
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-30">Advance</div>
                                  <div className="data-value w-70 ">
                                    <span className="change up text-danger">
                                      {materialData?.advancePercentage || "--"}%
                                    </span>
                                  </div>
                                </div>
                              )}
                              {materialData?.paymentTerms !=
                                "Cash and Carry" && (
                                  <div className="data-col align-center pt-1 ">
                                    <div className="data-label w-30">
                                      Credit Days
                                    </div>
                                    <div className="data-value w-70 ">
                                      <Badge color="outline-primary">
                                        {materialData?.creditDays || "--"} days
                                      </Badge>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </Col>
                        </div>
                      )}
                      {tab === "2" && (
                        <div className={`tab-pane${tab === "2" && " active"}`}>
                          <Col className="justify-start w-100  flex-wrap mt-3 p-0">
                            <div className="w-40  paddingLeft10 border-end">
                              <div className=" pt-1">
                                <div className="data-label w-90 mb-1">
                                  Billing Address
                                </div>
                                <div className="data-value w-90">
                                  <ShowBillingAddress
                                    address={materialData?.billingAddress}
                                  />
                                </div>
                              </div>
                            </div>
                            {materialData?.deliveryAddressId && (
                              <div className="w-40 paddingLeft10 ">
                                <div className=" pt-1">
                                  <div className="data-label w-9 mb-1">
                                    Delivery Address
                                  </div>
                                  <div className="data-value w-90">
                                    <ShowDeliveryAddress
                                      address={materialData?.deliveryAddress}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </Col>
                        </div>
                      )}
                    </div>
                  </Panel>
                  <span ref={bulkUploadErrorsRef}></span>
                  <Panel header="Material Information" key="2">
                    <Form form={form} component={false}>
                      <div className="d-flex justify-content-between m-0 p-0">
                        <div className="w-70 d-flex align-center">
                          {deliveryAddressList?.length > 0 && (
                            <Form.Item
                              name="invoiceDeliveryAddressId"
                              label=""
                              className="mb-0"
                              style={{ width: 200 }}
                              rules={[{ required: true, message: "Required" }]}
                            >
                              <Select
                                showSearch
                                allowClear
                                placeholder="Select a delivery address"
                                optionFilterProp="children"
                                defaultValue={selectedDeliveryAddress}
                                onChange={(data: any) => {
                                  setSelectedDeliveryAddress(data);
                                }}
                                onSearch={(data: any) => { }}
                                filterOption={(input, option: any) =>
                                  (option?.label ?? "")
                                    ?.toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                {deliveryAddressList?.map((item: any) => (
                                  <Option value={item?.id} key={item?.id}>
                                    {item?.deliveryLocationName}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          )}

                          {needByDateList?.length > 0 && (
                            <Form.Item
                              name="invoiceNeedByDate"
                              label=""
                              className="mb-0"
                              style={{ width: 200 }}
                              rules={[{ required: true, message: "Required" }]}
                            >
                              <Select
                                style={{ width: 200, marginLeft: "10px" }}
                                placeholder="Select Need By Date"
                                allowClear
                                optionFilterProp="children"
                                defaultValue={selectedNeedByDate}
                                onChange={(selectedOption: any) => {
                                  setSelectedNeedByDate(selectedOption);
                                }}
                                filterOption={(input: string, option: any) =>
                                  option?.label
                                    ?.toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                options={needByDateList?.map((item: any) => ({
                                  value: item,
                                  label: dayjs(item).format("DD-MMM-YYYY"),
                                }))}
                              />
                            </Form.Item>
                          )}
                          {OriginalData?.needByDateType == "Order Level" && (
                            <div className="paddingLeft10">
                              <strong>Need By Date</strong>
                              <p>{OriginalData?.needByDate}</p>
                            </div>
                          )}
                          {OriginalData?.deliveryAddressType ==
                            "Order Level" && (
                              <div
                                className="paddingLeft10"
                                style={{ marginLeft: "10px" }}
                              >
                                <strong>Delivery Address</strong>
                                <p>
                                  {
                                    OriginalData?.deliveryAddress
                                      ?.deliveryLocationName
                                  }
                                </p>
                              </div>
                            )}
                        </div>
                        <BulkMaterialUpload
                          moduleKey="order-to-invoice"
                          append={(data: any) => {
                            console.log("onUpload", data);
                            const { errorFlag, lines } = data;
                            if (errorFlag) {
                              setUploadedDataErrors(lines);
                            } else {
                              setUploadedDataErrors([]);
                            }
                            const LineNo: any = [];
                            lines?.forEach((row: any, index: any) => {
                              const {
                                lineId,
                                quantity,
                                hsnCode,
                                unitPrice,
                                errorFlag,
                              } = row;
                              if (errorFlag) return;
                              LineNo.push(lineId);
                              form.setFieldsValue({
                                [`invoiceQuantity_${lineId}`]: quantity,
                              });
                              form.setFieldsValue({
                                [`hsnCode_${lineId}`]: hsnCode,
                              });
                              form.setFieldsValue({
                                [`unitPrice_${lineId}`]: unitPrice,
                              });
                            });
                            onSelectChange(LineNo);
                          }}
                          extra={{
                            orderNumber: Number(orderNumber),
                            deliveryAddressId:
                              Number(selectedDeliveryAddress) || null,
                            needByDate: selectedNeedByDate
                              ? dayjs(selectedNeedByDate).format("YYYY-MM-DD")
                              : null,
                          }}
                        />
                      </div>
                      <Alert
                        isOpen={uploadedDataErrors?.length > 0}
                        color="danger"
                        className="start-0 w-100 py-1 mt-2 mb-0"
                        style={{
                          top: 0,
                          textAlign: "left",
                          fontSize: "14px",
                          cursor: "default",
                        }}
                      >
                        <Icon name={"info"} style={{ top: "0.6rem" }} />
                        <span>
                          Failed to prefill the data in the table due to an
                          issue with the inserted rows. You can{" "}
                          <Popconfirm
                            title={<></>}
                            icon={<></>}
                            showCancel={false}
                            open={uploadedDataErrorModal}
                            okButtonProps={{
                              style: {
                                display: "none",
                              },
                            }}
                            onConfirm={() => {
                              try {
                                console.log("confirm");
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            onCancel={() => {
                              alert("cancel");
                            }}
                            onOpenChange={(visible) => {
                              setUploadedDataErrorModal(visible);
                            }}
                            // arrow={false}
                            description={
                              <div
                                style={{
                                  width: "60vw",
                                  maxHeight: "400px",
                                  overflow: "scroll",
                                }}
                              >
                                {uploadedDataErrors?.map((row: any) => {
                                  const {
                                    errorMessage,
                                    materialName,
                                    lineId,
                                    errorFlag,
                                  } = row;
                                  if (errorFlag) {
                                    return (
                                      <Alert
                                        color="danger"
                                        className="start-0 w-100 py-1 mt-2"
                                        style={{
                                          top: 0,
                                          textAlign: "left",
                                          fontSize: "14px",
                                          cursor: "default",
                                          display: "flex",
                                        }}
                                      >
                                        <strong>
                                          {materialName} (Id: {lineId}) &nbsp;
                                          &nbsp;
                                        </strong>
                                        <ol>
                                          {errorMessage?.map((error: any) => (
                                            <li>{error}</li>
                                          ))}
                                        </ol>
                                      </Alert>
                                    );
                                  }
                                  return <></>;
                                })}
                              </div>
                            }
                          >
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                bulkUploadErrorsRef?.current?.scrollIntoView({
                                  behavior: "smooth",
                                });
                                setUploadedDataErrorModal(true);
                              }}
                              target="_self"
                              style={{ textDecoration: "underline" }}
                            >
                              <strong>view the details</strong>
                            </a>
                          </Popconfirm>
                          , update the file and reupload it.
                        </span>
                      </Alert>
                      <p className="ant-descriptions-item-content mb-2 mt-2">
                        <strong>Note : </strong>
                        Please select the material and enter the required data.
                        Alternatively, you can{" "}
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            let excelData: any = [];
                            filterData?.forEach((row: any) => {
                              let obj: any = {
                                "Line ID": row?.lineNo,
                                Material: row?.materialName,
                                "Available Qty to Invoice":
                                  Number(row?.quantity) -
                                  Number(row?.quantityInvoiced) +
                                  " " +
                                  row.uom,
                                Quantity: "",
                                HSN: row?.hsnCode,
                                "Price per Unit": Number(row?.unitPrice),
                              };

                              excelData.push(obj);
                            });
                            ExportToXlsx(
                              excelData,
                              "Invoice for PO " + OriginalData?.orderId
                            );
                          }}
                          target="_self"
                          style={{ textDecoration: "underline" }}
                        >
                          download the template
                        </a>{" "}
                        to fill in the details and upload it.
                      </p>
                      {filterData?.length > 0 ? (
                        <div className="table-responsive poTable  ">
                          <div
                            style={{
                              width: screenSize - 120 + "px",
                              margin: "0px auto",
                            }}
                          >
                            <Table
                              className="customTable"
                              columns={mergedColumns?.map((col) => {
                                if (
                                  col?.key == "invoiceQuantity" &&
                                  poStatus == "Fully Delivered"
                                ) {
                                  return {
                                    ...col,
                                    hidden: true,
                                  };
                                }
                                return col;
                              })}
                              rowSelection={
                                (OriginalData?.deliveryAddressType ==
                                  "Order Level" ||
                                  selectedDeliveryAddress) &&
                                  (OriginalData?.needByDateType ==
                                    "Order Level" ||
                                    selectedNeedByDate) &&
                                  poStatus != "Fully Delivered"
                                  ? rowSelection
                                  : undefined
                              }
                              components={{
                                body: {
                                  cell: EditableCell,
                                },
                              }}
                              dataSource={filterData.map((item: any) => ({
                                ...item,
                                key: item?.lineNo,
                              }))}
                              scroll={{ x: 1000 }}
                              expandable={{
                                expandedRowRender: (record: any) => (
                                  <div className="expandableBody">
                                    <div style={{ flex: 1, textAlign: "left" }}>
                                      <p style={{ margin: 0 }}>
                                        {record.description}
                                      </p>
                                      {record.file && (
                                        <div>
                                          <PaperClipOutlined /> &nbsp;
                                          <a
                                            href={record?.file?.fileName}
                                            download={record?.file?.fileName}
                                          >
                                            {record?.file?.fileName}
                                          </a>
                                        </div>
                                      )}
                                    </div>
                                    {materialData?.deliveryAddressType ===
                                      "Line Level" &&
                                      record.deliveryAddressId && (
                                        <div
                                          className="lineAddress"
                                          style={{ flex: 1 }}
                                        >
                                          <h6>Delivery Address</h6>
                                          <ShowAddressPopOver
                                            address={record?.deliveryAddress}
                                          />
                                        </div>
                                      )}
                                  </div>
                                ),
                              }}
                              bordered
                              size="middle"
                              pagination={false}
                            />
                          </div>

                          <div className="mt-2" style={{ float: "right" }}>
                            <Button
                              color="primary"
                              style={{ height: 40 }}
                              onClick={showDrawer}
                              disabled={selectedRowKeys.length === 0}
                            >
                              Preview Invoice
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "200px",
                          }}
                        >
                          <Empty description="No Data Available for this filter" />
                        </div>
                      )}
                    </Form>
                  </Panel>
                  <Panel header="Other Information" key="3">
                    <Descriptions title="" className="custom-description-title">
                      <Descriptions.Item label="Instructions">
                        <span
                          style={{
                            color: "#2263b3",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => setInstructionsVisible(true)}
                        >
                          View
                        </span>
                      </Descriptions.Item>
                      <Descriptions.Item label="Terms and Conditions">
                        <span
                          style={{
                            color: "#2263b3",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => setTermsVisible(true)}
                        >
                          View
                        </span>
                      </Descriptions.Item>
                      {attachments?.length > 0 && (
                        <Descriptions.Item label="">
                          <div>
                            <strong className="">
                              Attachments &nbsp;
                              <PaperClipOutlined />
                            </strong>
                            <div>
                              {attachments?.map(
                                (attachment: any, index: number) => (
                                  <div
                                    key={index}
                                    className="w-100 d-flex justify-content-between"
                                  >
                                    <div>
                                      <strong>{index + 1}.</strong>
                                      &nbsp;
                                      {attachment.name}
                                      &nbsp; &nbsp; &nbsp; &nbsp;
                                    </div>
                                    <div>
                                      <a
                                        href={attachment.link}
                                        download={attachment.link}
                                        style={{
                                          color: "black",
                                          fontSize: "18px",
                                        }}
                                      >
                                        <DownloadOutlined />
                                      </a>
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        </Descriptions.Item>
                      )}
                    </Descriptions>
                  </Panel>
                </AntCollapse>

                {drawerVisible && (
                  <Drawer
                    title={
                      <div className="d-flex justify-content-between align-items-center">
                        <strong>Create Invoice</strong>
                        <div style={{ textAlign: "right" }}>
                          {disableSubmit ? (
                            <Button color="primary" type="button">
                              <Spinner size="sm" color="light" />
                            </Button>
                          ) : (
                            <Button
                              onClick={() => {
                                handleSubmit2((data) => {
                                  setDisableSubmit(true);
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "You are about to create an invoice for this order!",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes, Create Invoice!",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      createInvoice(data);
                                    } else {
                                      setDisableSubmit(false);
                                    }
                                  });
                                })();
                              }}
                              color="primary"
                              className="m-3 mt-0 mb-0"
                            >
                              Create
                            </Button>
                          )}
                        </div>
                      </div>
                    }
                    placement="right"
                    onClose={closeDrawer}
                    open={drawerVisible}
                    width="85vw"
                    style={{
                      position: "absolute",
                      zIndex: 1100,
                    }}
                    styles={{
                      body: { paddingBottom: 80, paddingTop: 20 },
                      header: { padding: "8px 24px" },
                    }}
                  >
                    <FormProvider {...methods2}>
                      <form
                        onSubmit={handleSubmit2((data) => {
                          if (
                            !invoiceAttachments ||
                            invoiceAttachments.length === 0
                          ) {
                            Swal.fire({
                              icon: "error",
                              title: "Attachments Required",
                              text: "Please upload at least one document.",
                            });
                            return;
                          }
                          setDisableSubmit(true);
                          Swal.fire({
                            title: "Are you sure?",
                            text: "You are about to create an invoice for this order!",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes, Create Invoice!",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              createInvoice(data);
                            } else {
                              setDisableSubmit(false);
                            }
                          });
                        })}
                        autoComplete="off"
                      >
                        <div className="">
                          <h6>Billing & Other Information</h6>
                          <div className="w-100">
                            <div className="justify-start w-100  flex-wrap pt-0">
                              <div className={` w-30 p-3 pt-0 pb-0`}>
                                <div className=" pt-1 d-flex">
                                  <div className="data-label w-60">
                                    Billing Address
                                  </div>
                                  <div className="data-value ">
                                    <Popover
                                      content={
                                        <ShowBillingAddress
                                          address={materialData?.billingAddress}
                                        />
                                      }
                                    >
                                      <span
                                        style={{
                                          color: "#2263b3",
                                          textDecoration: "underline",
                                          cursor: "pointer",
                                        }}
                                      >
                                        View
                                      </span>
                                    </Popover>
                                  </div>
                                </div>
                              </div>
                              {materialData?.deliveryAddressType !=
                                "Line Level" &&
                                materialData?.deliveryAddressId && (
                                  <div className="w-30 p-3 pt-0 pb-0">
                                    <div className="pt-1 d-flex">
                                      <div className="data-label w-60">
                                        Delivery Address
                                      </div>
                                      <div className="data-value">
                                        <Popover
                                          content={
                                            <ShowDeliveryAddress
                                              address={
                                                materialData?.deliveryAddress
                                              }
                                            />
                                          }
                                        >
                                          <span
                                            style={{
                                              color: "#2263b3",
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                            }}
                                          >
                                            View
                                          </span>
                                        </Popover>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              {materialData?.deliveryAddressType ==
                                "Line Level" && (
                                  <div className="w-30 p-3 pt-0 pb-0 ">
                                    <div className=" pt-1 d-flex">
                                      <div className="data-label w-60">
                                        Delivery Address
                                      </div>
                                      <div className="data-value">
                                        <Popover
                                          content={
                                            <ShowDeliveryAddress
                                              address={deliveryAddressList?.find(
                                                (item: any) =>
                                                  item?.id ==
                                                  selectedDeliveryAddress
                                              )}
                                            />
                                          }
                                        >
                                          <span
                                            style={{
                                              color: "#2263b3",
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                            }}
                                          >
                                            View
                                          </span>
                                        </Popover>
                                      </div>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                          <div className="w-100" style={{ marginTop: "24px" }}>
                            <div
                              className="d-flex justify-content-start w-100 flex-wrap pt-3"
                              style={{ gap: "16px" }}
                            >
                              <div
                                style={{
                                  flex: "1 1 calc(33.333% - 12px)",
                                  minWidth: "250px",
                                  maxWidth: "calc(33.333% - 12px)",
                                }}
                                className="p-2 pt-0 pb-0"
                              >
                                <FormInput
                                  name="invoiceId"
                                  label="Invoice Number"
                                  placeholder="Invoice Number"
                                  required={true}
                                  onKeyDown={(event: any) => {
                                    const regex = /^[a-zA-Z0-9\/\-\|]+$/;
                                    if (
                                      !regex.test(event.key) &&
                                      ![
                                        "Backspace",
                                        "Delete",
                                        "ArrowLeft",
                                        "ArrowRight",
                                        "Tab",
                                      ].includes(event.key)
                                    ) {
                                      event.preventDefault();
                                    }
                                  }}
                                />
                              </div>
                              <div
                                style={{
                                  flex: "1 1 calc(33.333% - 12px)",
                                  minWidth: "250px",
                                  maxWidth: "calc(33.333% - 12px)",
                                }}
                                className="p-3 pt-0 pb-0"
                              >
                                <FormDatePicker
                                  name="invoiceDate"
                                  label="Invoice Date"
                                  placeholder="Invoice Date"
                                  required={true}
                                  minDate={
                                    OriginalData?.orderData
                                      ? dayjs(OriginalData?.orderData)
                                        .subtract(1, "day")
                                        .toDate()
                                      : undefined
                                  }
                                  maxDate={dayjs().toDate()}
                                  onChange={(date: any) => {
                                    setInvoiceDate(date || null);
                                  }}
                                />
                              </div>
                              <div
                                style={{
                                  flex: "1 1 calc(33.333% - 12px)",
                                  minWidth: "250px",
                                  maxWidth: "calc(33.333% - 12px)",
                                }}
                                className="p-3 pt-0 pb-0"
                              >
                                <FormSelect
                                  name="GrnRequired"
                                  label="GRN Required"
                                  placeholder="Select Invoice Type"
                                  required={true}
                                  options={[
                                    { label: "Yes", value: "true" },
                                    { label: "No", value: "false" },
                                  ]}
                                  onChange={handleGrnRequiredChange}
                                />
                              </div>
                              <div
                                style={{
                                  flex: "1 1 calc(33.333% - 12px)",
                                  minWidth: "250px",
                                  maxWidth: "calc(33.333% - 12px)",
                                }}
                                className="p-2 pt-0 pb-0"
                              >
                                <FormDatePicker
                                  name="dueDate"
                                  label="Payment Due Date"
                                  placeholder="Payment Due Date"
                                  required={true}
                                  minDate={
                                    invoiceDate && dayjs.isDayjs(invoiceDate)
                                      ? invoiceDate
                                        .add(
                                          Number(materialData?.creditDays) ||
                                          0,
                                          "day"
                                        )
                                        .toDate()
                                      : dayjs()
                                        .add(
                                          Number(materialData?.creditDays) ||
                                          0,
                                          "day"
                                        )
                                        .toDate()
                                  }
                                />
                              </div>
                              <div
                                style={{
                                  flex: "1 1 calc(33.333% - 12px)",
                                  minWidth: "250px",
                                  maxWidth: "calc(33.333% - 12px)",
                                }}
                                className="p-2 pt-0 pb-0"
                              >
                                <FormInput
                                  name="referenceId"
                                  label="IRN (Invoice Reference Number)"
                                  placeholder="Invoice Reference Number"
                                />
                              </div>
                              <div
                                style={{
                                  flex: "1 1 calc(33.333% - 12px)",
                                  minWidth: "250px",
                                  maxWidth: "calc(33.333% - 12px)",
                                }}
                                className="p-2 pt-0 pb-0"
                              >
                                <FormInput
                                  name="ewayBill"
                                  label="E-Way Bill"
                                  placeholder="E-Way Bill"
                                />
                              </div>
                            </div>
                          </div>
                          {grnRequired === "false" && (
                            <>
                              <div className="" style={{ marginTop: "24px" }}>
                                <h6>Transport Information</h6>
                              </div>
                              <div className="w-100">
                                <div
                                  className="d-flex justify-content-start w-100 flex-wrap pt-3"
                                  style={{ gap: "16px" }}
                                >
                                  {/* Initial 6 Fields */}
                                  <div
                                    style={{
                                      flex: "1 1 calc(33.333% - 12px)",
                                      minWidth: "250px",
                                      maxWidth: "calc(33.333% - 12px)",
                                    }}
                                    className="p-3 pt-0 pb-0"
                                  >
                                    <div style={{ position: 'relative' }}>
                                      <FormInput
                                        name="grnId"
                                        label="GRN Number"
                                        placeholder={numberingMode === 'auto' ? 'Auto-generated' : 'Enter GRN Number'}
                                        required={numberingMode === 'manual'}
                                        disabled={numberingMode === 'auto' || disableSubmit}
                                        type="text"
                                      />
                                      {/* Add debug display */}
                                      {/* <div style={{ fontSize: '10px', color: '#999', marginTop: '2px' }}>
                                        Form value: {getValue2("grnId") || 'empty'}
                                        <br />
                                        Mode: {numberingMode}
                                        <br />
                                        Sequence: {currentSiteSequence?.prefix || 'none'}
                                      </div> */}
                                      <Tooltip title="Click here to enable or disable auto-generation of GRN numbers.">
                                        <SettingOutlined
                                          style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50px',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer',
                                            fontSize: '18px',
                                            color: '#1890ff',
                                            zIndex: 1,
                                          }}
                                          onClick={() => {
                                            setTempNumberingMode(numberingMode);
                                            setShowNumberingModal(true);
                                          }}
                                        />
                                      </Tooltip>
                                    </div>
                                  </div>

                                  <div
                                    style={{
                                      flex: "1 1 calc(33.333% - 12px)",
                                      minWidth: "250px",
                                      maxWidth: "calc(33.333% - 12px)",
                                    }}
                                    className="p-3 pt-0 pb-0"
                                  >
                                    <FormDatePicker
                                      name="grnCreatedDate"
                                      label="GRN Date"
                                      placeholder="GRN Date"
                                      required={true}
                                      dateFormat="DD/MM/YYYY"
                                    />
                                  </div>

                                  <div
                                    style={{
                                      flex: "1 1 calc(33.333% - 12px)",
                                      minWidth: "250px",
                                      maxWidth: "calc(33.333% - 12px)",
                                    }}
                                    className="p-3 pt-0 pb-0"
                                  >
                                    <div style={{ marginBottom: "16px" }}>
                                      <FormSelect
                                        name="gateEntryId"
                                        label="Gate Entry No."
                                        placeholder="Select Gate Entry"
                                        required={true}
                                        options={gateEntriesOptions}
                                        isLoading={isLoadingGateEntries}
                                        onChange={(value: any, option: any) => {
                                          if (option) {
                                            const selectedOption =
                                              gateEntriesOptions.find(
                                                (opt: any) =>
                                                  opt.value === value
                                              );
                                            if (selectedOption) {
                                              setSelectedGateEntry({
                                                gateEntryId:
                                                  selectedOption.gateEntryId,
                                                gateEntryNumber:
                                                  selectedOption.gateEntryNumber,
                                              });
                                              // Also set gateEntryNumber in the form for reference
                                              setValue2(
                                                "gateEntryNumber",
                                                selectedOption.gateEntryNumber
                                              );
                                            }
                                          } else {
                                            setSelectedGateEntry(null);
                                            setValue2("gateEntryNumber", null);
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>

                                  {/* Row 2: Approval Required and Add More Button */}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "flex-end",
                                      width: "100%",
                                    }}
                                  >
                                    {/* Approval Required - Left */}
                                    <div
                                      style={{
                                        flex: "1 1 calc(33.333% - 12px)",
                                        minWidth: "250px",
                                        maxWidth: "calc(33.333% - 12px)",
                                      }}
                                      className="p-2 pt-0 pb-0"
                                    >
                                      <FormSelect
                                        name="autoRelease"
                                        label="Approval Required ?"
                                        options={[
                                          { label: "Yes", value: "true" },
                                          { label: "No", value: "false" },
                                        ]}
                                        placeholder="Select"
                                        required
                                      />

                                      <div style={{ display: "none" }}>
                                        <FormInput name="approvalsData" label="" type="text" noMaxLength />
                                      </div>

                                      {watch2("autoRelease") === "true" && (
                                        <Popover
                                          content="Click here to set required approvals"
                                          title="Approval Required"
                                        >
                                          <a
                                            href="#"
                                            className="success"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setApprovals((pre: any) => ({
                                                ...pre,
                                                open: true,
                                              }));
                                            }}
                                          >
                                            <EditOutlined /> Set Approvals{" "}
                                            {approvals?.data?.length === 0 && (
                                              <span className="mandatory">(Required)</span>
                                            )}
                                          </a>
                                        </Popover>
                                      )}
                                    </div>

                                    {/* Add More Button - Right */}
                                    <div>
                                      <Button
                                        type="button"
                                        color=""
                                        outline
                                        size={
                                          showMoreTransportFields
                                            ? "sm"
                                            : undefined
                                        }
                                        style={{
                                          backgroundColor: "transparent",
                                          border: "1px solid #d0d0d0",
                                          color: "#2263b3",
                                          padding: showMoreTransportFields
                                            ? "4px 8px"
                                            : "6px 12px",
                                          fontSize: showMoreTransportFields
                                            ? "12px"
                                            : "14px",
                                          height: "auto",
                                          lineHeight: "1.2",
                                        }}
                                        onClick={() =>
                                          setShowMoreTransportFields(
                                            !showMoreTransportFields
                                          )
                                        }
                                      >
                                        {showMoreTransportFields ? (
                                          <>
                                            <Icon
                                              name="minus"
                                              style={{ fontSize: "14px" }}
                                            />
                                          </>
                                        ) : (
                                          <>
                                            <Icon
                                              name="plus-round"
                                              style={{ fontSize: "16px" }}
                                            />
                                            <span style={{ marginLeft: "6px" }}>
                                              Add More
                                            </span>
                                          </>
                                        )}
                                      </Button>
                                    </div>
                                  </div>

                                  {/* Additional Fields - Shown when "Add More" is clicked */}
                                  {showMoreTransportFields && (
                                    <>
                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="vehicleNumber"
                                          label="Vehicle Number (eg: MH 12 AB 1234)"
                                          placeholder="Vehicle Number"
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="driverName"
                                          label="Driver Name"
                                          placeholder="Driver Name"
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="driverContact"
                                          label="Driver Contact"
                                          placeholder="Driver Contact"
                                          type="number"
                                          onKeyDown={(event: any) => {
                                            if (
                                              !/^[0-9]+$/.test(event.key) &&
                                              ![
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                              ].includes(event.key)
                                            ) {
                                              event.preventDefault();
                                            }
                                          }}
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormSelect
                                          name="vehicleType"
                                          label="Vehicle Type"
                                          placeholder="Select Vehicle Type"
                                          options={[
                                            {
                                              label: "Tipper truck",
                                              value: "tipper truck",
                                            },
                                            {
                                              label: "Concrete truck",
                                              value: "concrete truck",
                                            },
                                            {
                                              label: "Pickup truck",
                                              value: "pickup truck",
                                            },
                                            {
                                              label: "Small truck",
                                              value: "small truck",
                                            },
                                            {
                                              label: "Box truck",
                                              value: "box truck",
                                            },
                                            {
                                              label: "Boat haulage",
                                              value: "boat haulage",
                                            },
                                            {
                                              label: "Flatbed truck",
                                              value: "flatbed truck",
                                            },
                                            {
                                              label: "Tow truck",
                                              value: "tow truck",
                                            },
                                            {
                                              label: "Chiller truck or reefers",
                                              value: "chiller truck or reefers",
                                            },
                                            {
                                              label:
                                                "Crane trucks or mobile cranes",
                                              value:
                                                "crane trucks or mobile cranes",
                                            },
                                            {
                                              label: "Logging truck",
                                              value: "logging truck",
                                            },
                                            {
                                              label: "Tanker truck",
                                              value: "tanker truck",
                                            },
                                            {
                                              label: "Furniture truck",
                                              value: "furniture truck",
                                            },
                                            {
                                              label: "Snow plows",
                                              value: "snow plows",
                                            },
                                            {
                                              label: "Trailer Truck",
                                              value: "trailer Truck",
                                            },
                                            {
                                              label: "Off-road Truck",
                                              value: "off-road Truck",
                                            },
                                          ]}
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="driverEmail"
                                          label="Driver Email"
                                          placeholder="Driver Email"
                                          type="email"
                                          patternErrorMessage="Please enter a valid email address"
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="dharamkantaReceiptNo"
                                          label="Dharamkanta Receipt No."
                                          placeholder="Dharamkanta Receipt No."
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="dmrNo"
                                          label="DMR No."
                                          placeholder="DMR No."
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="weighbridgeSlipNo"
                                          label="Weighbridge Slip No."
                                          placeholder="Weighbridge Slip No."
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="ticketNo"
                                          label="Ticket No."
                                          placeholder="Ticket No."
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="youtubeLink"
                                          label="You Tube link"
                                          placeholder="You Tube link"
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="loadTruckWeight"
                                          label="Load Truck Weight"
                                          placeholder="Load Truck Weight"
                                          type="number"
                                          onKeyDown={(event: any) => {
                                            const regex = /^[0-9\b\.]+$/;
                                            if (
                                              !regex.test(event.key) &&
                                              ![
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                              ].includes(event.key)
                                            ) {
                                              event.preventDefault();
                                            }
                                          }}
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="emptyTruckWeight"
                                          label="Empty Truck Weight"
                                          placeholder="Empty Truck Weight"
                                          type="number"
                                          onKeyDown={(event: any) => {
                                            const regex = /^[0-9\b\.]+$/;
                                            if (
                                              !regex.test(event.key) &&
                                              ![
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                              ].includes(event.key)
                                            ) {
                                              event.preventDefault();
                                            }
                                          }}
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="netWeight"
                                          label="Net Weight"
                                          placeholder="Net Weight"
                                          type="number"
                                          onKeyDown={(event: any) => {
                                            const regex = /^[0-9\b\.]+$/;
                                            if (
                                              !regex.test(event.key) &&
                                              ![
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                              ].includes(event.key)
                                            ) {
                                              event.preventDefault();
                                            }
                                          }}
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormTimePicker
                                          name="vehicleInTime"
                                          label="Vehicle InTime"
                                          placeholder="Select Time"
                                          format="hh:mm A"
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormTimePicker
                                          name="vehicleOutTime"
                                          label="Vehicle OutTime"
                                          placeholder="Select Time"
                                          format="hh:mm A"
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="loadTruckWeightInHouse"
                                          label="Load Truck Weight In House"
                                          placeholder="Load Truck Weight"
                                          type="number"
                                          onKeyDown={(event: any) => {
                                            const regex = /^[0-9\b\.]+$/;
                                            if (
                                              !regex.test(event.key) &&
                                              ![
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                              ].includes(event.key)
                                            ) {
                                              event.preventDefault();
                                            }
                                          }}
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="emptyTruckWeightInHouse"
                                          label="Empty Truck Weight In House"
                                          placeholder="Empty Truck Weight"
                                          type="number"
                                          onKeyDown={(event: any) => {
                                            const regex = /^[0-9\b\.]+$/;
                                            if (
                                              !regex.test(event.key) &&
                                              ![
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                              ].includes(event.key)
                                            ) {
                                              event.preventDefault();
                                            }
                                          }}
                                        />
                                      </div>

                                      <div
                                        style={{
                                          flex: "1 1 calc(33.333% - 12px)",
                                          minWidth: "250px",
                                          maxWidth: "calc(33.333% - 12px)",
                                        }}
                                        className="p-3 pt-0 pb-0"
                                      >
                                        <FormInput
                                          name="netWeightInHouse"
                                          label="Net Weight In House"
                                          placeholder="Net Weight"
                                          type="number"
                                          onKeyDown={(event: any) => {
                                            const regex = /^[0-9\b\.]+$/;
                                            if (
                                              !regex.test(event.key) &&
                                              ![
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                              ].includes(event.key)
                                            ) {
                                              event.preventDefault();
                                            }
                                          }}
                                        />
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                        <AntCollapse
                          defaultActiveKey={["1", "2"]}
                          className="mt-3"
                        >
                          <Panel header={<h6>Material Information</h6>} key="1">
                            <div className="table-responsive poTable">
                              <div
                                style={{
                                  width: screenSize - 320 + "px",
                                  margin: "0px auto 15px auto",
                                }}
                              >
                                <Table
                                  className="customTable"
                                  columns={mergedColumns.map((col) => {
                                    if (col.dataIndex === "invoiceQuantity") {
                                      return {
                                        ...col,
                                        hidden: true,
                                        // render: (text: any, record: any) =>
                                        //   `${Number(text)} ${record.uom}`,
                                      };
                                    } else if (col.dataIndex === "operation") {
                                      return {
                                        ...col,
                                        hidden: true,
                                      };
                                    } else if (
                                      col.dataIndex === "availableQuantity"
                                    ) {
                                      return {
                                        ...col,
                                        hidden: true,
                                      };
                                    } else if (col.dataIndex == "grossTotal") {
                                      return {
                                        ...col,
                                        fixed: "right",
                                      };
                                    }
                                    return {
                                      ...col,
                                    };
                                  })}
                                  dataSource={invoiceableLines}
                                  scroll={{ x: 1000 }}
                                  expandable={{
                                    expandedRowRender: (record: any) => (
                                      <div className="expandableBody">
                                        <div
                                          style={{ flex: 1, textAlign: "left" }}
                                        >
                                          <p style={{ margin: 0 }}>
                                            {record.description}
                                          </p>
                                          {record.file && (
                                            <div>
                                              <PaperClipOutlined /> &nbsp;
                                              <a
                                                href={record?.file?.fileName}
                                                download={
                                                  record?.file?.fileName
                                                }
                                              >
                                                {record?.file?.fileName}
                                              </a>
                                            </div>
                                          )}
                                        </div>
                                        {/* {materialData?.deliveryAddressType ===
                                      "Line Level" &&
                                      record.deliveryAddressId && (
                                        <div
                                          className="lineAddress"
                                          style={{ flex: 1 }}
                                        >
                                          <h6>Delivery Address</h6>
                                          <ShowAddressPopOver
                                            address={record.deliveryAddress}
                                          />
                                        </div>
                                      )} */}
                                      </div>
                                    ),
                                  }}
                                  bordered
                                  size="middle"
                                  pagination={false}
                                />
                              </div>
                            </div>

                            <div className="d-flex justify-content-end">
                              <ViewTableTotals
                                data={invoiceableLines}
                                additionalCharges={[]}
                                invoice={true}
                              />
                            </div>
                            {/* <Row className="m-4 justify-content-end ">
                            {invoiceSignature?.isActive ? (
                              <div className="signatureBtnWrapper">
                                <div className="d-flex justify-content-between align-items-center">
                                  <strong>Signature</strong>
                                  <a
                                    style={{
                                      fontSize: "14px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setInvoiceSignature((prev: any) => ({
                                        ...prev,
                                        isActive: false,
                                        image: null,
                                        label: "Authorised Signatory",
                                      }));
                                      setValue("signatureObj", {
                                        isActive: false,
                                        image: null,
                                        label: "Authorised Signatory",
                                      });
                                    }}
                                  >
                                    <Icon
                                      name="cross"
                                      className="pointer"
                                      onClick={() => {
                                        setInvoiceSignature((prev: any) => ({
                                          ...prev,
                                          isActive: false,
                                          image: null,
                                          label: "Authorised Signatory",
                                        }));
                                        setValue("signatureObj", {
                                          isActive: false,
                                          image: null,
                                          label: "Authorised Signatory",
                                        });
                                      }}
                                    />
                                  </a>
                                </div>
                                <div
                                  style={{
                                    minHeight: invoiceSignature?.image
                                      ? "0px"
                                      : "120px",
                                    display: invoiceSignature?.image
                                      ? "block"
                                      : "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {!invoiceSignature?.image && (
                                    <Button
                                      color="btn-dim btn"
                                      onClick={() => {
                                        setShowCropModel(true);
                                      }}
                                    >
                                      <Icon
                                        name="upload-cloud"
                                        className="pointer"
                                        onClick={() => {
                                          setShowCropModel(true);
                                        }}
                                      />
                                      <span>Upload</span>
                                    </Button>
                                  )}
                                  {invoiceSignature?.image && (
                                    <>
                                      <div className="signatueImgWrapper border">
                                        <img
                                          src={invoiceSignature?.image}
                                          alt="Signed"
                                          style={{ width: "160px" }}
                                        />
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <Button
                                          color="btn-dim btn"
                                          onClick={() => {
                                            setInvoiceSignature((pre: any) => {
                                              return { ...pre, image: null };
                                            });
                                          }}
                                        >
                                          <span>Reset</span>
                                          <Icon
                                            name="redo"
                                            className="pointer"
                                            onClick={() => {
                                              setInvoiceSignature(
                                                (pre: any) => {
                                                  return {
                                                    ...pre,
                                                    image: null,
                                                  };
                                                }
                                              );
                                            }}
                                          />
                                        </Button>
                                      </div>
                                      <div>
                                        <div className="form-group">
                                          <label
                                            className="form-label"
                                            htmlFor="signatureLabel"
                                          >
                                            Signature Label
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="signatureLabel"
                                            onChange={(e) => {
                                              setInvoiceSignature(
                                                (pre: any) => {
                                                  return {
                                                    ...pre,
                                                    label: e.target.value,
                                                  };
                                                }
                                              );
                                            }}
                                            defaultValue={
                                              invoiceSignature?.label ||
                                              "Authorised Signatory"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>

                                {!invoiceSignature?.image && (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Button
                                        color="btn-dim btn"
                                        onClick={() =>
                                          setShowSignatureModel(true)
                                        }
                                      >
                                        <Icon name="pen" />
                                        <span>Use Signature Pad</span>
                                      </Button>
                                    </div>
                                  </>
                                )}
                              </div>
                            ) : (
                              <div
                                style={{
                                  border: "1px solid #e5ecf7",
                                  backgroundColor: "#f7faff",
                                  padding: "10px",
                                  marginLeft: "10px",
                                  width: "22%",
                                  borderRadius: "5px",
                                  textAlign: "center",
                                }}
                              >
                                <Button
                                  color="btn-dim btn"
                                  onClick={() => {
                                    setInvoiceSignature((pre: any) => {
                                      return { ...pre, isActive: true };
                                    });
                                  }}
                                >
                                  <Icon
                                    name="edit"
                                    className="pointer"
                                    onClick={() => {
                                      setInvoiceSignature((pre: any) => {
                                        return { ...pre, isActive: true };
                                      });
                                    }}
                                  />
                                  <span>Add Signature</span>
                                </Button>
                              </div>
                            )}
                          </Row> */}
                          </Panel>
                          <Panel
                            header={<h6>Attachments (If Any) </h6>}
                            key="3"
                          >
                            <div className="form-group">
                              <Dragger
                                beforeUpload={beforeUpload}
                                onChange={handleChange}
                                fileList={invoiceAttachments}
                                maxCount={3}
                                multiple={true}
                                accept=".pdf,.jpg,.jpeg,.png"
                              >
                                <AntButton icon={<UploadOutlined />}>
                                  Click to Upload
                                </AntButton>
                              </Dragger>
                              {invoiceAttachments?.length === 0 && (
                                <p className="mandatory">
                                  Please upload at least one document.
                                </p>
                              )}
                            </div>
                          </Panel>
                        </AntCollapse>
                        {showCropModel && (
                          <CropperComponent
                            modal={showCropModel}
                            toggle={() => setShowCropModel(!showCropModel)}
                            onSave={(data: string) => {
                              setInvoiceSignature((pre: any) => {
                                return { ...pre, image: data };
                              });
                              setShowCropModel(false);
                            }}
                          />
                        )}
                        {showSignatureModel && (
                          <SignatureModal
                            modal={showSignatureModel}
                            toggle={() =>
                              setShowSignatureModel(!showSignatureModel)
                            }
                            onSave={(data: string) => {
                              setInvoiceSignature((pre: any) => {
                                return { ...pre, image: data };
                              });
                              setShowSignatureModel(false);
                            }}
                          />
                        )}
                      </form>
                    </FormProvider>
                  </Drawer>
                )}

                <AntModal
                  title="Instructions"
                  open={instructionsVisible}
                  footer={null}
                  onCancel={() => setInstructionsVisible(false)}
                  width="60%"
                  styles={{ body: { maxHeight: "70vh", overflowY: "auto" } }}
                >
                  {instructions ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: instructions,
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "200px",
                      }}
                    >
                      <Empty description="No Instructions Provided for this Purchase Order" />
                    </div>
                  )}
                </AntModal>
                <AntModal
                  title="Terms and Conditions"
                  open={termsVisible}
                  footer={null}
                  onCancel={() => setTermsVisible(false)}
                  width="60%"
                  styles={{ body: { maxHeight: "70vh", overflowY: "auto" } }}
                >
                  {termsAndConditions ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: termsAndConditions,
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "200px",
                      }}
                    >
                      <Empty description="No Terms and Conditions Provided for this Purchase Order" />
                    </div>
                  )}
                </AntModal>
              </div>
            </div>
          </div>
        </Card>
      </Content>
      <Modal
        isOpen={generalInformationEdit}
        toggle={() => setGeneralInformationEdit(false)}
        className="modal-dialog-centered"
        size="xl"
        backdrop="static"
      >
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setGeneralInformationEdit(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>

        <ModalBody>
          {tab == "2" && (
            <>
              <h5 className="title"> Update Delivery Info</h5>
              <div style={{ marginTop: "15px" }}></div>
              <FormProvider {...methods}>
                <form
                  onSubmit={handleSubmit((data) => {
                    setMaterialData((pre: any) => {
                      return {
                        ...pre,
                        ...data,
                      };
                    });
                    setGeneralInformationEdit(false);
                    console.log(data);
                  })}
                >
                  <Row className="gy-4 mt-1">
                    <Col lg="4">
                      <FormSelect
                        name="inwardRequired"
                        label="GRN Required ?"
                        options={[
                          { label: "Yes", value: true },
                          { label: "No", value: false },
                        ]}
                        disabled={true}
                        placeholder="-Select-"
                        tooltipText=" If GRN (Inward Process) is required for the line items then you can select 'Yes' otherwise select 'No'."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="needByDateType"
                        disabled
                        label="Line Level Delivery ?"
                        options={[
                          { label: "Yes", value: "Line Level" },
                          { label: "No", value: "Order Level" },
                        ]}
                        placeholder="-Select-"
                        tooltipText="delivery date will be based on the line level. If you select 'No' then delivery date will be based on the Order Level."
                      />
                    </Col>
                    {watch("needByDateType") == "Order Level" && (
                      <Col lg="4">
                        <FormDatePicker
                          name="needByDate"
                          label="Delivery Date"
                          required={true}
                          minDate={new Date()}
                        />
                      </Col>
                    )}
                    <Col lg="4">
                      <FormInput
                        name="billingAddress"
                        label={`Billing Address`}
                        disabled
                        placeholder="-Select-"
                        tooltipText="Select the billing address for the purchase order."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="deliveryAddressType"
                        label={`Delivery Address`}
                        disabled
                        options={[
                          { label: "Order Level", value: "Order Level" },
                          { label: "Line Level", value: "Line Level" },
                        ]}
                        placeholder="-Select-"
                        tooltipText="Select the delivery address type for the purchase order."
                      />
                    </Col>
                    {watch("deliveryAddressType") === "Order Level" && (
                      <Col lg="4">
                        <FormInput
                          name="deliveryAddress"
                          label="Delivery Address"
                          placeholder="-Select-"
                          tooltipText="Select the delivery address for the purchase order."
                          disabled
                        />
                      </Col>
                    )}
                  </Row>
                  <Row className="mt-4">
                    <Col lg="12">
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                        <li>
                          <Button
                            className="btn btn-primary btn-md"
                            type="submit"
                            color="primary"
                          >
                            Save
                          </Button>
                        </li>
                        <li>
                          <a
                            href="#cancel"
                            onClick={(ev) => {
                              ev.preventDefault();
                              setGeneralInformationEdit(false);
                              reset();
                            }}
                            className="link link-light"
                          >
                            Cancel
                          </a>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </form>
              </FormProvider>
            </>
          )}
        </ModalBody>
      </Modal>

      {approvals.open && (
        <GRNApprovalDrawer
          open={approvals.open}
          siteId={siteIdWatch || materialData?.siteId}
          onClose={() => {
            setApprovals((pre: any) => {
              return {
                ...pre,
                open: false,
              };
            });
          }}
          onSubmit={(data: any, isStrictApprovalFromDrawer: boolean) => {
            setApprovals({
              open: false,
              data: data,
            });
            setIsStrictApproval(isStrictApprovalFromDrawer);
          }}
          initialStrictApproval={isStrictApproval}
          setApprovalSubmissionStatus={(status: boolean) => { }}
          approvalData={approvals.data}
        />
      )}

      {/* GRN Number Configuration Modal */}
      <AntdModal
        title="Configure GRN Number Preference"
        open={showNumberingModal}
        onCancel={() => setShowNumberingModal(false)}
        zIndex={1200}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px" }}>
            <Button
              key="save"
              color="primary"
              onClick={() => {
                if (tempNumberingMode === "auto" && !currentSiteSequence) {
                  message.error("Auto-generation is not configured for this site.");
                  return;
                }

                setNumberingMode(tempNumberingMode);

                if (tempNumberingMode === "auto" && currentSiteSequence) {
                  const { prefix } = currentSiteSequence;
                  const grnNumber = `${prefix}`;
                  setValue2("grnId", grnNumber);
                } else if (tempNumberingMode === "manual") {
                  setValue2("grnId", "");
                }

                setShowNumberingModal(false);
              }}
            >
              Save
            </Button>

            <Button
              key="cancel"
              color="primary"
              onClick={() => setShowNumberingModal(false)}
            >
              Cancel
            </Button>
          </div>
        }
      >
        <div style={{ marginBottom: 20, lineHeight: "22px" }}>
          Your GRN numbers are currently set to auto-generate to save time.
          <br />
          Are you sure you want to change this setting?
        </div>

        {!materialData?.siteId && (
          <div style={{ color: "#8c8c8c", marginBottom: 16 }}>
            <InfoCircleOutlined /> Please select a site first to configure GRN numbering.
          </div>
        )}

        {materialData?.siteId && !currentSiteSequence && (
          <div style={{ color: "#faad14", marginBottom: 16 }}>
            <InfoCircleOutlined />{" "}
            {activeSequences.length === 0
              ? "No sequences configured for GRN. Please set up a sequence first in Sequence Master."
              : "No sequence configured for the selected site. Please set a sequence for this site in Sequence Master."}
          </div>
        )}

        <Radio.Group
          onChange={(e) => setTempNumberingMode(e.target.value)}
          value={tempNumberingMode}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <Radio value="auto" disabled={!canAuto}>
              <span style={{ fontWeight: 500 }}>
                Continue auto-generating GRN numbers
              </span>
              {!canAuto && materialData?.siteId && (
                <span style={{ color: "#8c8c8c", marginLeft: 8, fontSize: 12 }}>
                  (Not available - no sequence configured)
                </span>
              )}
            </Radio>

            <Radio value="manual">
              <span style={{ fontWeight: 500 }}>
                Enter GRN numbers manually
              </span>
            </Radio>
          </Space>
        </Radio.Group>
      </AntdModal>
    </>
  );
};

const fetchHtmlContentFromUrl = async (url: string) => {
  try {
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "text/html",
      },
    });

    return response?.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};
const ShowAddressPopOver = ({ address }: any) => {
  return (
    <ul>
      <li>
        <strong style={{ color: "#2263b3" }}>
          {address?.deliveryLocationName}
        </strong>
      </li>
      <li>{address?.addressLine1}</li>
      <li>{address?.addressLine2}</li>
      <li>
        {address?.city}, {address?.stateName}, {address?.countryName} -{" "}
        {address?.pincode}
      </li>
    </ul>
  );
};

export default PoInvoiceDetails;
